export const flex = {
    display: 'flex'
};
export const spaceBetween = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
};
export const rowCenter = {
    display: 'flex',
    justifyContent: 'center'
};
export const colCenter = {
    display: 'flex',
    alignItems: 'center'
};
